/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_CancelInputs */

const vi_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ`)
};

/**

* @param {Action_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const action_cancel = /** @type {((inputs?: Action_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_action_cancel(inputs)
});